import script from "./ChangeDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangeDetailView.vue?vue&type=script&setup=true&lang=js"

import "./ChangeDetailView.vue?vue&type=style&index=0&id=064e7827&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-064e7827"]])

export default __exports__